/*
 * Authors: mariushirjanu
 * Created: 12/10/2021
 */
import { Component, EventEmitter } from '@angular/core';
import { Input, Output, OnInit } from '@angular/core';
import { IUserData } from '../../shared/services/auth/auth-data.service';
import { util } from '../../shared/util';

@Component({
  selector: 'user-profile-wrapper',
  template: `
    <default-dialog hideHeader="true" hideFooter="true">
      <user-profile [userId]="userId" [companyId]="companyId" [countryId]="countryId" [firstName]="firstName" [genericUserFn]="genericUserFn" (onSaved)="onSaved.emit($event)" (onCancel)="onCancel.emit()" [showCancelButton]="showCancelButton">
        <button *ngIf="!showCancelButton" type="button" class="btn-close" (click)="onCancel.emit()">
          <span class="visually-hidden">Close</span>
        </button>
      </user-profile>
    </default-dialog>
  `
})
export class UserProfileWrapperComponent implements OnInit {
  @Input() public userId:string;
  @Input() public companyId:number;
  @Input() public countryId:number;
  @Input() public firstName:string;
  @Input() public genericUserFn:Function;
  @Input() public showCancelButton?:boolean;

  @Output() public onSaved:EventEmitter<{ userData:IUserData }> = new EventEmitter();
  @Output() public onCancel:EventEmitter<void> = new EventEmitter();

  public ngOnInit():void {
    if(util.isNullOrUndefined(this.showCancelButton)){
      this.showCancelButton = true;
    }
  }
}